import React, { useEffect, useState } from 'react';
import { IMyDownloadContextValue, IMyDownloadStatusMessage } from './mydownload-provider-types';

export const MyDownloadContext = React.createContext({
	myDownloadStatus: [] as IMyDownloadStatusMessage[],
	updateMyDownloadStatus: (data: IMyDownloadStatusMessage) => {},
});

const MyDownloadProvider = ({ children }: any) => {
	const [myDownloadStatus, setMyDownloadStatus] = useState<IMyDownloadStatusMessage[]>([]);

	const updateMyDownloadStatus = (data: IMyDownloadStatusMessage): void => {
		setMyDownloadStatus((prevState) => [...prevState, data]);
	};

	const value: IMyDownloadContextValue = {
		myDownloadStatus,
		updateMyDownloadStatus,
	};
	return <MyDownloadContext.Provider value={value}>{children}</MyDownloadContext.Provider>;
};

export default MyDownloadProvider;
